import { render, staticRenderFns } from "./UserFactoryRelationsEditForm.vue?vue&type=template&id=599152d4&scoped=true&"
import script from "./UserFactoryRelationsEditForm.vue?vue&type=script&lang=ts&"
export * from "./UserFactoryRelationsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserFactoryRelationsEditForm.vue?vue&type=style&index=0&id=599152d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599152d4",
  null
  
)

export default component.exports